import {
	AlertSubscriptionCell,
	SeverityCell,
	VisibilityCell,
	SubscriptionsCell,
	SubscribedCell,
	ActionsCell,
} from 'features/IRWorkstation/components/AlertCenter/AlertSubscriptionList/AlertSubscriptionColumnDisplay';

// -------------------------------------------------------------------------
// All Columns
// -------------------------------------------------------------------------

export const AlertSubscriptionColumnDefinitions = ({
	handleSubscribe,
	handleUnsubscribe,
	handleRunNow,
	handleDeleteRule,
	expandedRowIds,
	onToggleRule,
	onViewReportInCrm,
} = {}) => [
	{
		field: 'title',
		headerName: 'Alert',
		editable: false,
		sortable: false,
		flex: 6,
		minWidth: 300,
		renderCell: (params) => (
			<AlertSubscriptionCell
				params={params}
				isRuleExpanded={expandedRowIds?.includes(params.row.id)}
				onToggleRule={onToggleRule}
				onViewReportInCrm={onViewReportInCrm}
			/>
		),
	},
	{
		field: 'severity',
		headerName: 'Severity',
		editable: false,
		sortable: false,
		flex: 1,
		minWidth: 100,
		display: 'flex',
		renderCell: (params) => <SeverityCell params={params} />,
	},
	{
		field: 'visibility',
		headerName: 'Visibility',
		editable: false,
		sortable: false,
		flex: 1,
		minWidth: 100,
		display: 'flex',
		renderCell: (params) => <VisibilityCell params={params} />,
	},
	{
		field: 'subscription_count',
		headerName: 'Subscriptions',
		editable: false,
		sortable: false,
		flex: 1,
		minWidth: 140,
		display: 'flex',
		renderCell: (params) => <SubscriptionsCell params={params} />,
	},
	{
		field: 'subscribed',
		headerName: 'Subscribed',
		editable: false,
		sortable: false,
		resizable: false,
		flex: 1,
		minWidth: 120,
		display: 'flex',
		renderCell: (params) => (
			<SubscribedCell
				params={params}
				handleSubscribe={handleSubscribe}
				handleUnsubscribe={handleUnsubscribe}
			/>
		),
	},
	{
		field: 'actions',
		headerName: 'Actions',
		type: 'actions',
		editable: false,
		sortable: false,
		resizable: false,
		flex: 1,
		minWidth: 80,
		display: 'flex',
		getActions: (params) =>
			ActionsCell({ params, handleRunNow, handleDeleteRule }),
	},
];
